export default "__VITE_ASSET__txgT5B7r__"